import isNil from 'lodash/isNil';
import pickBy from 'lodash/pickBy';

export function filterEmptyProps<T extends object>(obj: T, filterEmptyArrays?: boolean): Partial<T> {
  return pickBy(obj, prop => isNotEmpty(prop, filterEmptyArrays));
}

export function isNotEmpty(prop: any, filterEmptyArrays = false): boolean {
  // check if array should be filtered, otherwise check for null, undefined or empty string
  return filterEmptyArrays && Array.isArray(prop) ? !!prop.length : !(isNil(prop) || prop === '');
}
